/*
 *
 * File JS list Cards
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./marquee.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const marquee = () => {
    let allMarquee = document.querySelectorAll(".marquee");
    if (!allMarquee.length) return;

    allMarquee.forEach((marquee) => {
        let el = marquee.querySelector(".marquee__loop");
        el.innerHTML = el.innerHTML + el.innerHTML;

        let content = marquee.querySelector(".marquee__content");

        repeatContent(content, window.innerWidth);

        function repeatContent(el, till) {
            let html = el.innerHTML;
            let counter = 0;
            setTimeout(function () {
                while (el.offsetWidth < till && counter < 100) {
                    el.innerHTML +=
                        marquee.querySelector(".marquee__content").innerHTML;
                    counter += 1;
                }
            }, 100);
        }
    });
};

export default marquee;

//--------------------------------------------------------------------//
